import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Button from "../../common/Button";
import { downloadTestFeedback, testFeedbackUrl } from "../../api/profileApi";
import {
  isDownloadAttrSupported,
  forceDownload,
} from "../../containers/ResourceFolders/util";

const downloadFeedback = async (testName) => {
  if (isDownloadAttrSupported()) {
    return downloadTestFeedback(testName).then((response) =>
      forceDownload(
        response,
        "Nonverbal_Immediacy_Scale_Test_Feedback_Fields.pdf"
      )
    );
  }
  return window.open(testFeedbackUrl(testName), "_blank");
};
const NonverbalImmediacyIndex = ({ appData }) => {
  return (
    <article>
      <div className="styles__resource__wrapper___EooDq">
        <h4 className="styles__resource__title___3swKq">
          Nonverbal Immediacy Test
        </h4>
        <p className="styles__resource__description___2yhR0">
          <b>
            Nonverbal Immediacy is a term used to describe the behaviours used
            to signal positive feelings towards another person. The idea was
            based in the works of Albert Mehrabian done in the 1970s. The
            Nonverbal Immediacy Scale measures individual differences in
            expression of nonverbal immediacy and was developed by Virginia
            Richmond, James McCrotsky and Aaron Johnson in 2003.
            <br />
            <br />
            The test consists of twenty six behaviours that you must rate on how
            often you exhibit them. The test should take 4 - 8 minutes to
            complete.
            <br />
            <br />
            This test is provided for educational use only. It should not be
            used as psychological advice of any kind and comes without any
            guarantee of accuracy or fitness for any particular purpose.
            <br />
            <br />
            In taking this test, you consent to HRGO storing and processing the
            information you provide in order to provide you with the test
            result. The information you provide may also be used to find the
            most suitable job for you, to share with clients, train our data
            models, improve and iterate these tests, and provide you with the
            most relevant advertising and courses. Where the data does not
            require attribution; we will anonymise your information for
            processing.
            <br />
            <br />
            {appData.nonverbalImmediacyTestHandling
              ? " Please click Download to get your feedback."
              : " Please click Launch to complete this test."}
          </b>
        </p>
        <div className="d-flex flex-column">
          {appData.nonverbalImmediacyTestHandling ? (
            <Button
              onClick={() => {
                downloadFeedback("nonverbalImmediacy");
              }}
              id="btnBasicInfoEditSubmit"
              classes="btn btn-primary ml-auto"
            >
              Download
            </Button>
          ) : (
            <Link
              to="/profile/MyTests/NonverbalImmediacy"
              className="btn btn-primary ml-auto"
            >
              Launch
            </Link>
          )}
        </div>
      </div>
    </article>
  );
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, null);
export default withRedux(NonverbalImmediacyIndex);
